import { createContext } from "react";

export const DemoLeadCaptureContext = createContext({
  showModal: () => {},
  triggerOptimizeSuccess: () => {},
  routePhones: null,
  dismissRoutePhones: () => {},
  requestedDemo: false,
  markDemoRequested: () => {},
  openKeepAccount: () => {},
});
